import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../auth/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PipasModule() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [tab, setTab] = useState("resumen");
  const [filtroZona, setFiltroZona] = useState("");

  const refrescar = () => {
    axios.get(`${API}/pipas/dashboard`).then((r) => setData(r.data));
  };

  useEffect(() => {
    refrescar();
  }, []);

  if (!data) return <div className="p-10 text-slate-500" data-testid="pipas-loading">Cargando módulo Pipas…</div>;

  const { kpis, pipas, dia } = data;
  const pipasFiltradas = filtroZona ? pipas.filter(p => p.zonas?.includes(filtroZona)) : pipas;
  const zonasUnicas = [...new Set(pipas.flatMap(p => p.zonas || []))].sort();

  return (
    <div className="hub-bg" data-testid="page-pipas">
      <header className="topnav">
        <div className="brand">
          <button onClick={() => navigate("/hub")} className="iconbtn mr-1" aria-label="Atrás" data-testid="btn-back-hub">
            <i className="fa-solid fa-arrow-left"/>
          </button>
          <div className="logo" style={{background: "var(--dep-pipas)"}}><i className="fa-solid fa-truck-droplet"/></div>
          <div>
            <div className="title">Módulo Pipas</div>
            <div className="sub">Riego áreas verdes · {dia}</div>
          </div>
        </div>
        <div className="actions">
          <div className="hidden sm:block text-right mr-2">
            <div className="text-sm font-semibold leading-tight">{user?.nombre}</div>
            <div className="text-xs text-slate-500">{user?.rol}</div>
          </div>
          <button onClick={logout} className="btn-ghost" data-testid="btn-logout-pipas" style={{padding:"0.5rem 0.9rem"}}>
            <i className="fa-solid fa-right-from-bracket mr-1"/>Salir
          </button>
        </div>
      </header>

      <main className="max-w-6xl mx-auto px-5 py-7">
        <h1 className="text-2xl sm:text-3xl font-bold leading-tight" data-testid="pipas-title">
          Operación de hoy · <span className="capitalize">{dia.toLowerCase()}</span>
        </h1>
        <p className="text-slate-500 text-sm mt-1">Datos en tiempo real de las 17 pipas en flota.</p>

        {/* KPI cards */}
        <section className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-5 gap-3 mt-6 mb-8" data-testid="kpi-grid">
          <Kpi value={kpis.total_pipas}       label="Pipas en flota"     icon="fa-truck-droplet" color="var(--accent)" />
          <Kpi value={kpis.puntos_asignados_hoy} label="Puntos asignados"  icon="fa-map-pin"       color="var(--purple)" />
          <Kpi value={kpis.atendidos}          label="Atendidos hoy"     icon="fa-check"          color="var(--green)" />
          <Kpi value={kpis.pendientes}         label="Pendientes"         icon="fa-clock"          color="var(--amber)" />
          <Kpi value={`${kpis.cumplimiento_pct}%`} label="Cumplimiento"   icon="fa-chart-pie"      color="var(--green)" big />
          <Kpi value={kpis.recargas_garza}     label="Recargas garza"    icon="fa-faucet-drip"    color="var(--accent)" />
          <Kpi value={kpis.ayudas_bomberos}    label="Apoyos bomberos"   icon="fa-truck-medical"  color="var(--red)" />
          <Kpi value={kpis.puntos_nuevos}      label="Puntos nuevos"     icon="fa-map-pin"        color="var(--green)" />
          <Kpi value={`${kpis.pct_gps}%`}      label="Cobertura GPS rutas" icon="fa-location-dot"   color="var(--purple)" sub={`${kpis.puntos_con_gps}/${kpis.puntos_con_gps+kpis.puntos_sin_gps} puntos`} />
          <Kpi value={`${kpis.pct_gps_catalogo}%`} label="GPS catálogo 2026" icon="fa-tree"           color="var(--green)"  sub={`${kpis.catalogo_con_gps}/${kpis.catalogo_total} parques`} big />
          <Kpi value={kpis.no_localizados}     label="No localizados"   icon="fa-question"        color="var(--text-muted)" />
        </section>

        {/* Tabs */}
        <div className="flex flex-wrap gap-2 mb-4" data-testid="pipas-tabs">
          <TabBtn k="resumen"     cur={tab} set={setTab} label="Pipas en flota"/>
          <TabBtn k="zonas"       cur={tab} set={setTab} label="Cobertura por zona"/>
          <TabBtn k="urgentes"    cur={tab} set={setTab} label="Atención inmediata"/>
        </div>

        {tab === "resumen" && (
          <section className="card-base" data-testid="tab-resumen">
            <div className="flex flex-wrap justify-between items-end mb-3 gap-2">
              <div className="text-sm font-semibold">Flota completa ({pipasFiltradas.length})</div>
              <div>
                <select className="text-sm border border-slate-300 rounded-md px-2 py-1 bg-white" value={filtroZona} onChange={(e)=>setFiltroZona(e.target.value)} data-testid="filtro-zona">
                  <option value="">Todas las zonas</option>
                  {zonasUnicas.map(z => <option key={z} value={z}>{z}</option>)}
                </select>
              </div>
            </div>
            <div className="overflow-x-auto -mx-4">
              <table className="w-full text-sm" data-testid="tabla-pipas">
                <thead className="bg-slate-50 text-xs uppercase tracking-wider text-slate-500">
                  <tr>
                    <th className="text-left p-3">Pipa</th>
                    <th className="text-left p-3">Chofer</th>
                    <th className="text-left p-3">Zona(s) / Tipo</th>
                    <th className="text-left p-3">Estado operativo</th>
                    <th className="text-right p-3">Hoy</th>
                    <th className="text-right p-3">Atendidos</th>
                    <th className="text-right p-3">% cumpl.</th>
                    {user?.rol === "admin" && <th className="text-center p-3">Taller</th>}
                  </tr>
                </thead>
                <tbody>
                  {pipasFiltradas.map((p) => {
                    const ESTADOS = {
                      EN_RUTA:     { bg: "#D1FAE5", color: "#047857", icon: "fa-truck-fast",   lbl: "En ruta" },
                      COMPLETADA:  { bg: "#DBEAFE", color: "#1E40AF", icon: "fa-circle-check", lbl: "Completada" },
                      NO_INICIADA: { bg: "#F1F5F9", color: "#475569", icon: "fa-circle-pause", lbl: "Sin iniciar" },
                      EN_TALLER:   { bg: "#FEF3C7", color: "#92400E", icon: "fa-screwdriver-wrench", lbl: "En taller" },
                      SIN_RUTA:    { bg: "#E2E8F0", color: "#64748B", icon: "fa-bed",           lbl: "Sin ruta hoy" },
                    };
                    const e = ESTADOS[p.estado_operativo] || ESTADOS.SIN_RUTA;
                    const enTaller = p.estado_operativo === "EN_TALLER" || p.en_taller === true;
                    const tipoLbl = p.tipo === "ZONAL_TRATADA" ? "Tratada · zonal"
                                  : p.tipo === "ZONAL_POTABLE" ? "Potable · zonal"
                                  : p.tipo === "DEDICADA"      ? `Dedicada · ${p.servicio_dedicado || "—"}`
                                  : p.tipo || "—";
                    return (
                      <tr key={p.id_pipa}
                          className="border-t border-slate-100 hover:bg-slate-50"
                          data-testid={`row-pipa-${p.id_pipa}`}
                          style={enTaller ? { background: "#FFFBEB", opacity: 0.9 } : undefined}>
                        <td className="p-3 mono font-semibold align-top">
                          {enTaller && <i className="fa-solid fa-lock mr-1" style={{color: "#92400E"}} title="En taller"/>}
                          {p.id_pipa}
                        </td>
                        <td className="p-3 align-top">{p.chofer_nombre || <span className="text-slate-400">—</span>}</td>
                        <td className="p-3 align-top">
                          <div className="flex gap-1 flex-wrap">
                            {(p.zonas||[]).map(z => <span key={z} className="pill-tiny pill-zone">{z}</span>)}
                            {!(p.zonas||[]).length && <span className="text-xs text-slate-400">sin zonas</span>}
                          </div>
                          <div className="text-xs text-slate-500 mt-1">{tipoLbl}</div>
                        </td>
                        <td className="p-3 align-top">
                          <span className="estatus-pill" style={{ background: e.bg, color: e.color }}>
                            <i className={`fa-solid ${e.icon}`}/> {e.lbl}
                          </span>
                          {p.minutos_desde_ult_actividad !== null && p.minutos_desde_ult_actividad !== undefined && (
                            <div className="text-xs text-slate-500 mt-1">hace {p.minutos_desde_ult_actividad} min</div>
                          )}
                        </td>
                        <td className="p-3 text-right font-semibold align-top">{p.puntos_hoy}</td>
                        <td className="p-3 text-right text-emerald-700 font-semibold align-top">{p.atendidos_hoy}</td>
                        <td className="p-3 text-right align-top">
                          <span className="mono" style={{color: p.cumplimiento_hoy_pct >= 80 ? "var(--green)" : p.cumplimiento_hoy_pct >= 40 ? "var(--amber)" : "var(--red)"}}>
                            {p.cumplimiento_hoy_pct}%
                          </span>
                        </td>
                        {user?.rol === "admin" && (
                          <td className="p-3 text-center align-top">
                            <BotonToggleTaller pipa={p} enTaller={enTaller} onChange={refrescar}/>
                          </td>
                        )}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </section>
        )}

        {tab === "zonas" && (
          <section className="card-base" data-testid="tab-zonas">
            <div className="text-sm font-semibold mb-3">Cobertura por zona — {kpis.puntos_con_gps} puntos con GPS de {kpis.puntos_con_gps + kpis.puntos_sin_gps} ({kpis.pct_gps}%)</div>
            <div className="space-y-3">
              {zonasUnicas.map(z => {
                const pipasZ = pipas.filter(p => p.zonas?.includes(z));
                const con = pipasZ.reduce((acc,p)=>acc+(p.puntos_con_gps||0),0);
                const tot = pipasZ.reduce((acc,p)=>acc+(p.puntos_ruta||0),0);
                const pct = tot ? Math.round(con/tot*100) : 0;
                return (
                  <div key={z} className="flex items-center gap-4 p-3 rounded-lg bg-slate-50" data-testid={`zona-row-${z}`}>
                    <div className="mono font-bold w-12">{z}</div>
                    <div className="flex-1">
                      <div className="flex justify-between text-xs mb-1.5 text-slate-500">
                        <span>{pipasZ.map(p=>p.id_pipa).join(", ")}</span>
                        <span><strong className="text-slate-700">{con}/{tot}</strong> con GPS · {pct}%</span>
                      </div>
                      <div className="h-2 bg-slate-200 rounded-full overflow-hidden">
                        <div className="h-full bg-emerald-500" style={{width: `${pct}%`}}/>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </section>
        )}

        {tab === "urgentes" && (
          <section className="card-base" data-testid="tab-urgentes">
            <div className="text-sm font-semibold mb-3 text-rose-700">⚠ Atención inmediata para el lunes</div>
            <ul className="space-y-3">
              <Urgente icon="fa-user-tie" color="var(--red)" titulo="3 zonas sin supervisor de áreas contratadas" desc="Z1, Z6, Z16 · 186 parques sin responsable directo. Plantear a Rubén antes del lanzamiento."/>
              <Urgente icon="fa-location-dot" color="var(--amber)" titulo={`${kpis.puntos_sin_gps} puntos sin GPS`} desc="Los choferes deben capturar GPS la primera vez que visiten cada punto. Premiar a la zona con mayor cobertura."/>
              <Urgente icon="fa-question-circle" color="var(--purple)" titulo="526 espacios sin clasificar (sin dato 2020)" desc="Los supervisores de área deben validar si requieren pipa o no, en la próxima fase."/>
              <Urgente icon="fa-truck-droplet" color="var(--accent)" titulo="Catálogo de pipas completo hasta Z14" desc="Las zonas Z15-Z20 no existen en el sistema — el catálogo cubre Z1-Z14."/>
            </ul>
          </section>
        )}

        <div className="text-xs text-slate-400 mt-8 mono">Actualizado {new Date().toLocaleString("es-MX")}</div>
      </main>
    </div>
  );
}

function Kpi({ value, label, icon, color, big, sub }) {
  return (
    <div className={`card-base ${big ? "ring-2 ring-emerald-200" : ""}`} data-testid={`kpi-${label}`}>
      <div className="flex justify-between items-start mb-2">
        <i className={`fa-solid ${icon} text-lg`} style={{ color }}/>
      </div>
      <div className="text-2xl font-bold leading-none" style={{ color }}>{value}</div>
      <div className="text-xs text-slate-500 mt-1.5">{label}</div>
      {sub && <div className="text-xs text-slate-400 mt-0.5 mono">{sub}</div>}
    </div>
  );
}

function TabBtn({ k, cur, set, label }) {
  return (
    <button onClick={() => set(k)} className={`px-4 py-2 rounded-full text-sm font-semibold transition ${cur===k?"bg-slate-900 text-white":"bg-white border border-slate-300 text-slate-700 hover:bg-slate-100"}`} data-testid={`tab-${k}`}>
      {label}
    </button>
  );
}

function Urgente({ icon, color, titulo, desc }) {
  return (
    <li className="flex gap-3 p-4 rounded-lg" style={{ background: "rgba(244, 63, 94, 0.06)" }}>
      <div className="w-10 h-10 rounded-lg grid place-items-center text-white shrink-0" style={{ background: color }}>
        <i className={`fa-solid ${icon}`}/>
      </div>
      <div>
        <div className="font-semibold text-slate-800">{titulo}</div>
        <div className="text-sm text-slate-600 mt-0.5">{desc}</div>
      </div>
    </li>
  );
}

// 15-jun-2026 (Octavio): toggle admin para enviar/sacar pipa del taller
function BotonToggleTaller({ pipa, enTaller, onChange }) {
  const [enviando, setEnviando] = useState(false);
  const accion = async () => {
    let motivo = null;
    if (!enTaller) {
      motivo = window.prompt(`¿Por qué entra al taller la pipa #${pipa.id_pipa}?`, "");
      if (motivo === null) return; // cancelado
    } else {
      if (!window.confirm(`¿Regresar la pipa #${pipa.id_pipa} a operación?`)) return;
    }
    setEnviando(true);
    try {
      await axios.post(`${API}/admin/pipas/${pipa.id_pipa}/en-taller`, {
        en_taller: !enTaller,
        motivo: motivo || undefined,
      });
      onChange?.();
    } catch (e) {
      window.alert(e?.response?.data?.detail || "Error al cambiar estado");
    } finally {
      setEnviando(false);
    }
  };
  return (
    <button
      onClick={accion}
      disabled={enviando}
      data-testid={`btn-toggle-taller-${pipa.id_pipa}`}
      style={{
        background: enTaller ? "#15803D" : "#92400E",
        color: "white",
        border: 0,
        padding: "6px 10px",
        borderRadius: 6,
        fontWeight: 700,
        fontSize: 11,
        cursor: enviando ? "wait" : "pointer",
        whiteSpace: "nowrap",
      }}
      title={enTaller ? "Regresar a operación" : "Enviar al taller"}
    >
      <i className={`fa-solid ${enTaller ? "fa-rotate-left" : "fa-screwdriver-wrench"} mr-1`}/>
      {enviando ? "…" : enTaller ? "Regresar" : "A taller"}
    </button>
  );
}
